// extracted by mini-css-extract-plugin
export default {"wrapper":"editor_wrapper__nh5Ag"};